<template>
  <layout-content>
    <tabs
      type="card"
      :animated="false"
      :value="$route.params.type"
      @on-click="$router.push({ to: 'mailer.stats.type', params: { type: $event } })"
    >
      <tab-pane
        v-for="tab in ['general', 'detailed']"
        :key="tab"
        :name="tab"
        :label="$t(`shared.breadcrumb.stats.${tab}`)"
      />
    </tabs>
    <component :is="`stats-${$route.params.type}`" v-if="$user.sms_stats_from_new_module_allowed" />
    <component :is="`archived-${$route.params.type}`" v-else />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    components: {
      'stats-general': () => import('@mailer/components/stats/mailings-stats-general'),
      'stats-detailed': () => import('@mailer/components/stats/mailings-stats-detailed'),
      'archived-general': () => import('@mailer/components/stats/archived-mailings-stats-general'),
      'archived-detailed': () => import('@mailer/components/stats/archived-mailings-stats-detailed')
    },

    watch: {
      '$route.params.type': {
        handler: function () {
          this.add_breadcumbs({
            item: {
              title: `shared.breadcrumb.stats.${this.$route.params.type}`,
              route: {
                name: 'mailer.stats.type',
                params: { type: this.$route.params.type }
              }
            }
          });
        },

        immediate: true
      }
    },

    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcumbs: 'add_item' })
    }
  };
</script>
